/**
 * Named app icon renderer — looks up TSX glyphs by kebab name.
 * Replaces the old asset-based `SvgIcon`.
 */
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { appIconMap, type AppIconName } from './appIconMap';

export type { AppIconName };

export type AppIconLookupProps = {
  name: AppIconName | string;
  size?: number;
  color?: string;
  style?: StyleProp<ViewStyle>;
};

export function AppIcon({ name, size, color, style }: AppIconLookupProps) {
  const IconComponent = appIconMap[name as AppIconName];
  if (!IconComponent) {
    return null;
  }
  return <IconComponent size={size} color={color} style={style} />;
}

export default AppIcon;
